import React from 'react';
import ReactDOM from 'react-dom';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';



const CONTROL_WIDTH = 210

const styles = theme => ({
  formControl: {
    minWidth: CONTROL_WIDTH,
  },
  textField: {
    paddingRight: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    width: CONTROL_WIDTH,
  },
  select: {
    width: CONTROL_WIDTH - 16,
  },
  inputProps: {
    textAlign: 'right',
  }
});


class SalesTaxForm extends React.Component {

  state = {}

  state = {
    labelWidth: 0,
  };

  componentDidMount() {
    this.setState({
      labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth,
    });
  }


  render = () => {
    const {classes, order, actions, showErrors} = this.props

    const {
      _errors,
      laborTaxRate,
      partsTaxCalculation,
      partsTaxRate,
    } = order

    return (
      <div>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="body1" style={{marginBottom: `2em`}}>
              Note: If the entire repair is taxable in your state, enter zeroes
              below to allow sales tax calculations by your technicians in the
              field. Sales tax may then be shown as a separate line item on your
              invoice.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <TextField
            fullWidth
              error={!!((laborTaxRate || showErrors) && _errors.laborTaxRate)}
              className={classes.textField}
              variant="outlined"
              label="Labor Tax Rate"
              value={laborTaxRate}
              onChange={e => actions.updateOrder(order, {laborTaxRate: e.target.value})}
              InputProps={{ inputProps: {className: classes.inputProps}, endAdornment: <InputAdornment position="end">%</InputAdornment>, }}
            />
          </Grid>
          <Grid item xs={12} sm={5} md={3}>
            <TextField
              error={!!((partsTaxRate || showErrors) && _errors.partsTaxRate)}
              className={classes.textField}
              variant="outlined"
              label="Parts Tax Rate"
              value={partsTaxRate}
              onChange={e => actions.updateOrder(order, {partsTaxRate: e.target.value})}
              InputProps={{ inputProps: {className: classes.inputProps}, endAdornment: <InputAdornment position="end">%</InputAdornment>, }}
            />
          </Grid>
          <Grid item xs={12} sm={5} md={3}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel ref={ref => { this.InputLabelRef = ref }} htmlFor="outlined-parts-tax-calc" >
                Compute Parts Tax on
              </InputLabel>
              <Select
                error={!!(showErrors && _errors.partsTaxCalculation)}
                variant="outlined"
                value={partsTaxCalculation}
                onChange={e => actions.updateOrder(order, {partsTaxCalculation: e.target.value})}
                input={
                  <OutlinedInput
                    labelWidth={this.state.labelWidth}
                    id="outlined-parts-tax-calc"
                    name="partsTaxCalculation"
                    className={classes.select}
                  />
                }
              >
                <MenuItem value="Tax Cost">Cost of Parts</MenuItem>
                <MenuItem value="Tax Sale">Retail Price of Parts</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" style={{margin: `2em 0`}}>
              We cannot advise about the collection and submission of taxes. All
              sales tax issues should be discussed with your sales tax advisors.
              We can only let you know how sales tax will be calculated in your
              books based on the information you provide.
            </Typography>
          </Grid>
        </Grid>
      </div>
    )
  }
}

SalesTaxForm.propTypes = {
  order: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default withStyles(styles)(SalesTaxForm);
